export default __webpack_public_path__ + "static/SR France - 2022 General Conditions of Sale-2352dd7df28592af3a7fecc683188a65.pdf";